<aside class="mainCta">
  <a class="btn btn-pulse" (click)="clickLink()" [title]="title" [target]="target">
  <span>{{label}}</span>
    <!--    TODO: Revisar si compensa adaptar maquetación y usar componente neo-icono -->
    <!--  <neo-icono-->
    <!--    [iconoClase]="iconoClase"-->
    <!--  ></neo-icono>-->
    <i [ngClass]="iconoClase"></i>
  </a>
</aside>


<neo-main-acciones-dialogo-cta #accionesDialogoCta
   [tituloDialog]="tituloDialog"
   [label]="'llamada_ctc' | transloco"
   [descripcionDialog]="descripcionDialog"
   [tfnoCta1]="tfnoCta1"
   [tfnoCta2]="tfnoCta2"
   [mailCta]="mailCta">
  </neo-main-acciones-dialogo-cta>
